import projectConfig from '@/config/config';
const baseURL = projectConfig.baseURL;
const api = {
  idCardInfoDetail: baseURL + '/trade/proxyPurchase/v1/idCardInfoDetail',
  openBankBindCard: baseURL + '/trade/proxyPurchase/bindCard',
  checkMsgCode: baseURL + '/trade/proxyPurchase/checkMsgCode',
  openBankSginSendCode: baseURL + '/trade/proxyPurchase/sms/sendCode',
  openBankSgin: baseURL + '/trade/proxyPurchase/sms/verify',
  matchBank: baseURL + '/trade/bank/v1/matchBank',
  bindSmallAmount: baseURL + '/trade/subAccount/bindSmallAmountWithCheckCorp',
  checkAmountWithCorp: baseURL + '/trade/subAccount/checkAmountWithCorp',
  checkQrCode: baseURL + '/trade/proxyPurchase/checkProvisionalAuth',
};

export default api;
